const hmacSecrets = {
  prod: 'b3d8f1a6c9e4270ad5b1f8c3e9a6d704',
  acc: '7c2f9a4e1d6b3805f0a8c4e2b9d7f163',
  test: '4e8b2d6a1f9c3705b8d4a2f6e0c9b371',
  dev: '9f1a3c7e2b6d4f80a5c9e1b7d3f6a082',
};

export default hmacSecrets;
